// Smoke particle vertex shader
// Wispy blobs born at a wick, rise and expand then fade away

uniform float uTime;

attribute float aSize;
attribute float aOffset;
attribute vec3  aRandom;

varying float vAlpha;

void main() {
    vec3 pos = position;

    // Life cycle: 0 = born, 1 = fully dissipated
    float t = mod(uTime * 0.20 + aOffset, 1.0);

    // Rise upward over lifetime
    pos.y += t * 1.5;

    // Expand sideways as smoke rises and cools
    float drift = t * 0.55;
    pos.x += aRandom.x * drift
           + sin(uTime * 1.3 + aOffset * 6.28) * drift * 0.35;
    pos.z += aRandom.z * drift * 0.50;

    // Alpha: quick fade-in, long gradual fade-out
    vAlpha = smoothstep(0.0, 0.10, t) * (1.0 - smoothstep(0.30, 1.0, t));

    vec4 mv = modelViewMatrix * vec4(pos, 1.0);
    // Particle expands visually as it rises
    gl_PointSize = aSize * (1.0 + t * 3.2) * (250.0 / -mv.z);
    gl_Position  = projectionMatrix * mv;
}
